import axios from "axios";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import AddBarcodeScanner from "./screens/AddBarcodeScannerView";
import AddBarcode from "./screens/AddBarcodeView";
import AllSuppliersView from "./screens/AllSuppliersView.js";
import Assortiment from "./screens/AssortimentView.js";
import Basket from "./screens/BasketView";
import ConfirmOrder from "./screens/ConfirmOrderView";
import ConfirmSignUp from "./screens/ConfirmSignUpView.js";
import DeliveryOptionView from "./screens/DeliveryOptionView.js";
import Favorites from "./screens/FavoritesView";
import Home from "./screens/HomeScreenView";
import Login from "./screens/LoginView";
import OrderHistory from "./screens/orderHistoryView";
import ProductInfoView from "./screens/ProductInfoScreen.js";
import Profile from "./screens/ProfileView";
import PublicAssortiment from "./screens/PublicAssortimentView.js";
import Scanner from "./screens/ScannerView";
import ScheduleDelivery from "./screens/ScheduleDeliveryView";
import SignUp from "./screens/SignUpView.js";
import SingleOrder from "./screens/SingleOrderView";
import SuppliersInfoView from "./screens/SuppliersInfoView.js";
import { storeUrl } from "./services/currentInformation/actions.js";
import { identify } from "./services/identify/actions";
import ConditionalRoute from "./utils/conditionalRoute.js";
import NotFound from "./utils/NotFound.js";
import requireAuth from "./utils/requireAuth";

//Set Axios Defaults
axios.defaults.baseURL = "https://easyapp.bestelsysteem.net/webapi";
axios.defaults.headers.common["Content-Type"] = "application/json";

//Add Every Axios Request and Response to Console // TEST ONLY
axios.interceptors.request.use((request) => {
  return request;
});

axios.interceptors.response.use((response) => {
  return response;
});

function App(props) {
  useEffect(() => {
    if (!props.loginSuccesful) {
      //props.identify(window.location.hostname);
      props.identify("goeieete.easy-dish.app");
    }
  }, []);

  useEffect(() => {
    //To clear store when entered from different url
    if (window.location.hostname != props.storedUrl) {
      window.localStorage.clear();
      props.storeUrl(window.location.hostname);
      window.location.href = window.location.origin + window.location.pathname;
    }
  }, [window.location.hostname]);

  const determineInitialRoute = () => {
    let params = new URLSearchParams(window.location.search);
    const urlToken = params.get("key");
    if (props.identifyInfo.public && urlToken == null) {
      // publiek domein
      //FIXEN
      if (props.loginSuccesful) {
        // publiek domein en ingelogd
        axios.defaults.headers.common["Token"] = props.token;
        axios.defaults.headers.common["Authorization"] = props.authorization;
        if (props.farmers) {
          // publiek domein en ingelogd en boerenassortiment
          return <Redirect to="/home" />;
        } else {
          // publiek domein maar geen boerenassortiment
          return <Redirect to="/assortiment" />;
        }
      } else {
        // publiek domein en niet ingelogd
        return <Redirect to="/home" />;
      }
    } else {
      // zakelijk domein
      return <Redirect to="/login" />;
    }
  };

  function getFaviconEl() {
    return document.getElementById("favicon");
  }

  function getFaviconEl2() {
    return document.getElementById("faviconhs");
  }

  useEffect(() => {
    if (props.identifyInfo) {
      const favicon = getFaviconEl(); // Accessing favicon element
      favicon.href = props.identifyInfo.favicon;

      const favicon_hs = getFaviconEl2();
      favicon_hs.href = props.identifyInfo.favicon;
    }
  }, [props.identifyInfo]);

  return props.identifyInfo ? (
    <HashRouter>
      <Switch>
        <Route exact path="/">
          {determineInitialRoute()}
        </Route>
        <ConditionalRoute
          component={PublicAssortiment}
          path={"/publicassortiment"}
          condition={props.identifyInfo.public && !props.loginSuccesful}
          requireAuth={false}
        />
        <ConditionalRoute
          component={Home}
          path={"/home"}
          condition={!props.business && props.identifyInfo.public} //OR public domain gebruiken
          requireAuth={false}
        />
        {/* <Route path="/publicassortiment" render={PublicAssortiment} /> */}
        <ConditionalRoute
          component={PublicAssortiment}
          path={"/farmersassortiment"}
          condition={props.farmers}
          requireAuth={true}
        />
        {/* <Route path="/farmersassortiment" component={requireAuth(PublicAssortiment)} /> */}
        <Route path="/supplierinfo" render={SuppliersInfoView} />
        <Route path="/allsuppliers" render={AllSuppliersView} />
        <Route path="/productinfo" component={ProductInfoView} />
        <Route path="/login" component={Login} />
        <ConditionalRoute
          component={SignUp}
          path={"/signup"}
          condition={props.identifyInfo.public}
          requireAuth={false}
        />
        {/* <Route path="/signup" component={SignUp} /> */}
        <ConditionalRoute
          component={ConfirmSignUp}
          path={"/confirmsignup"}
          condition={props.identifyInfo.public}
          requireAuth={false}
        />
        {/* <Route path="/confirmsignup" component={ConfirmSignUp} /> */}
        <Route path="/singleorder" component={requireAuth(SingleOrder)} />
        {/* <Route path="/assortiment" component={requireAuth(Assortiment)} /> */}
        <ConditionalRoute
          component={Assortiment}
          path={"/assortiment"}
          condition={!props.farmers}
          requireAuth={true}
        />
        <Route path="/basket" component={requireAuth(Basket)} />
        <Route path="/profile" component={requireAuth(Profile)} />
        <Route path="/confirmorder" component={requireAuth(ConfirmOrder)} />
        <Route path="/favorites" component={requireAuth(Favorites)} />
        {/* <Route
					path="/scheduledelivery"
					component={requireAuth(ScheduleDelivery)}
				/> */}
        <ConditionalRoute
          component={ScheduleDelivery}
          path={"/scheduledelivery"}
          condition={props.business}
          requireAuth={true}
        />
        <ConditionalRoute
          component={DeliveryOptionView}
          path={"/order_delivery_choice"}
          condition={!props.business}
          requireAuth={true}
        />

        <Route path="/orderhistory" component={requireAuth(OrderHistory)} />
        <ConditionalRoute
          component={Scanner}
          path={"/scanner"}
          condition={props.stock_count}
          requireAuth={true}
        />
        <ConditionalRoute
          component={AddBarcode}
          path={"/addbarcode"}
          condition={props.add_barcodes}
          requireAuth={true}
        />
        <ConditionalRoute
          component={AddBarcodeScanner}
          path={"/addbarcodescanner"}
          condition={props.add_barcodes}
          requireAuth={true}
        />
        <Route path="*" component={NotFound} />
      </Switch>
    </HashRouter>
  ) : null;
}

const mapStateToProps = (state) => ({
  stock_count: state.login.data.stock_count,
  add_barcodes: state.login.data.add_barcodes,
  identifyInfo: state.identify.identifyInfo,
  loginSuccesful: state.login.data.loginSuccesful,
  business: state.login.data.business,
  farmers: state.login.data.farmers,
  token: state.login.data.token,
  authorization: state.login.data.authorization,
  storedUrl: state.currentInformation.stored_url,
});

export default connect(mapStateToProps, { identify, storeUrl })(App);
